import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsors-particulars',
  templateUrl: './sponsors-particulars.component.html',
  styleUrls: ['./sponsors-particulars.component.scss'],
})
export class SponsorsParticularsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
